<template>
  <div>
    <div class="header mb-8"><span class="font-weight-bold">선택 정보</span>를 입력해주세요</div>
    <div class="vertical-line mb-6"></div>
    <v-col>
      <v-col>
        <v-col class="mb-1">
          <div class="label">가입 경로</div>
        </v-col>
        <v-col>
          <v-select
            v-model="form.route"
            :items="
              Object.entries(option.root).map(([k, v]) => ({
                value: k,
                text: v,
              })) || []
            "
            item-text="text"
            class="font-13"
            item-value="value"
            outlined
            solo
            flat></v-select>
        </v-col>
        <v-col class="mb-1">
          <div class="label">추천인</div>
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.recommended"
            class="font-13"
            name="recommended"
            placeholder="추천인을 입력해주세요"
            type="text"
            :rules="[errors.first('recommended') || !errors.has('recommended')]"
            single-line
            outlined
            solo
            flat
            required>
          </v-text-field>
        </v-col>
      </v-col>
    </v-col>
    <v-btn class="submit mb-4" text outlined @click="handleClick()">완료</v-btn>
  </div>
</template>

<script>
export default {
  name: 'OptionalInfo',
  data() {
    return {
      option: { root: {} },
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    nextStep: {
      type: Function,
      default: () => {},
    },
  },
  created() {
    this.axios
      .get('/company/option')
      .then(option => {
        delete option.data.root['A'];
        delete option.data.root['B'];
        this.option = option.data;
      })
      .catch(err => {
        console.log(err);
      });
  },

  methods: {
    async handleClick() {
      const leadId = this.$route.query.leadId;
      console.log(leadId);

      let payload = {};

      if (!leadId) {
        // 도입 문의를 하지 않고 회원가입을 한 경우
        payload = {
          email: this.form.email,
          password: this.form.password,
          route: this.form.route,
          recommended: this.form.recommended,
          companyName: this.form.name,
          adCategory: this.form.type,
          contact: this.form.contact,
          x: this.form.x,
          y: this.form.y,
          agreeToMarketing: this.form.isMarketingAgreed,
        };
      } else {
        // 도입 문의를 하고 회원가입을 한 경우
        payload = {
          email: this.form.email,
          password: this.form.password,
          route: this.form.route,
          recommended: this.form.recommended,
          leadId: leadId,
        };
      }

      try {
        if (this.userIsAuthenticated) {
          await this.$store.dispatch('logout');
        }
        await this.$store.dispatch('membersSignup', payload);
        this.nextStep();
      } catch (error) {
        this.$store.commit('setMsg', error);
        this.$store.commit('setShowSnackbar', true);
        // window.location.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/form.scss';
@import '../../../assets/scss/typo.scss';

.header {
  color: #000;
  font-size: 24px;
  font-style: normal;
  line-height: normal;
}

.vertical-line {
  width: 100%;
  height: 1px;
  background-color: #c2c2c2;
  opacity: 0.3;
}

.content {
  color: #3a3a3a;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}

.label {
  color: var(--default-color);
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
}

::v-deep .v-list-item__title {
  font-size: 14px; /* 원하시는 크기로 조절 */
}
</style>
